import stringSchema from "@/lib/utils/stringSchema";
import { z } from "zod";

const formSchema = z.object({
  notice_message: stringSchema({ key: "Message", required: true }),
  notice_active: z.boolean(),
  start_date: z.preprocess((arg) => {
    if (typeof arg === "string" || arg instanceof Date) {
      return new Date(arg);
    }
    return arg;
  }, z.date()),
  end_date: z.preprocess((arg) => {
    if (typeof arg === "string" || arg instanceof Date) {
      return new Date(arg);
    }
    return arg;
  }, z.date()),
  hide_from_client: z.boolean().nullable(),
}).refine((data) => data.start_date <= data.end_date, {
  message: "Start date cannot be greater than end date",
  path: ["start_date"],
});

export default formSchema;
